import Mask from './Mask'
import {
  lockBodyOverflow,
  restoreBodyOverflow
} from '@utils/dom'

const cache = {}

let locked = false

function noop() {
  // noop
}

function create(
  {
    classname = '',
    color = null,
    opacity = null,
    onClick = noop,
    zIndex = null
  },
  overlayInstance,
  parentElement = 'body'
) {
  const instance = new Mask({ classname, color, opacity, onClick, zIndex }, overlayInstance, parentElement)
  if (!cache[parentElement]) {
    cache[parentElement] = []
  }
  cache[parentElement].push(instance)
  return instance
}

function show(instance) {
  if (!instance) {
    return
  }
  const parentElement = instance.parentElement
  for (let i = 0; i < cache[parentElement].length; i++) {
    if (cache[parentElement][i] !== instance) {
      cache[parentElement][i].hide()
    } else {
      cache[parentElement][i].show()
      lockBodyOverflow()
      locked = true
    }
  }
}

function hide(instance) {
  if (!instance) {
    return
  }
  let hasLowerMask = false
  const parentElement = instance.parentElement
  const index = cache[parentElement].indexOf(instance)
  if (index > 0) {
    instance.hide()
    for (let i = index - 1; i >= 0; i--) {
      if (cache[parentElement][i].show()) {
        hasLowerMask = true
      }
    }
  } else {
    instance.hide()
  }
  if (!hasLowerMask && locked) {
    restoreBodyOverflow()
    locked = false
  }
}

function destroy(instance) {
  if (!instance) {
    return
  }
  const parentElement = instance.parentElement
  const index = cache[instance.parentElement].indexOf(instance)
  cache[parentElement].splice(index, 1)
  instance.destroy()
}

export default {
  create,
  show,
  hide,
  destroy
}
